<div class="content-wrapper-inner">
  <div class="page-content">
    <div [hidden]="!loading" class="spinner">
      <div class="sk-spinner sk-spinner-pulse"></div>
    </div>
  </div>
  <h1 class="main-title">Billing</h1>
  <ng-container *ngIf="itemsMt.length">
    <h2 class="subtitle">Overview <span *ngIf="user">You are logged in are <span class="user-email">{{ user.email }}</span></span></h2>
    <div class="card current-plan">
      <div class="current-balance">
        <h4>Total balance <i tooltip="Based on {{testsCount}} tests sent" class="icon icon-help-1 text-neutral-n6"></i></h4>
        <span class="balance">
          <ng-container *ngIf="currentBalance < 0">-</ng-container>
          €{{ (currentBalance < 0 ? (currentBalance * -1) : currentBalance) | numberFormat: '0.00' }} </span>
            <span class="available-tests"> based on {{ testsCount }} tests sent
              {{analyticsTariff?.rate ? 'and monthly active analytics service': '' }}</span>
      </div>
    </div>
  </ng-container>

  <h2 class="subtitle">
    Plan usage
  </h2>

  <ng-container *ngIf="progressMt">
    <div class="card">
      <h4> Mobile Termination (MT) usage</h4>
      <div class="d-flex align-items-end">
        <span class="balance">{{getCurrentAmountSpentOnTier(itemsMt)}}</span>
        <span class="text-primary fw-bold p-12">{{progressMt.label}}</span>
      </div>
      <app-billing-progress [total]="progressMt.total" [current]="progressMt.current" [parts]="progressMt.parts"></app-billing-progress>

      <ul class="quotas-list mt-0_6">
        <li *ngFor="let item of itemsMt;let i=index" [style.width.%]="100 / itemsMt.length">
          {{getRatePerTest(itemsMt, i)}}/test
        </li>
      </ul>
      <div class="text-muted mt-24">
        Each tier in the usage bar represents a volume quota. Once a quota is reached, your test price is recalculated based on the lower rate.
        <br>This discount is applied retroactively to all tests conducted within the month, not just those performed after reaching the quota.
      </div>
      <hr *ngIf="commitmentMt" class="line-break">
      <ng-container *ngIf="commitmentMt">
        <h4>Mobile Termination (MT) commitment</h4>
        <div class="mt-0_8">
          <div class="d-flex align-items-baseline">
            <span class="commitment-balance">{{ commitmentMt | currency:'EUR':'symbol':'1.1-3' }} </span><span class="ms-0_6"> per month</span>
          </div>
          <div class="text-muted mt-16">
            Commitment is the minimum charge that applies each month, irrespective of your testing usage. <br>For instance, if your commitment is
            set at
            €250 and your usage amounts to €100, you will still be invoiced for the €250. If your usage exceeds the commitment, you'll be charged
            based on
            the actual usage.
          </div>
        </div>
      </ng-container>
    </div>
  </ng-container>

  <ng-container *ngIf="progressMo">
    <div class="card">
      <h4>Mobile Originated (MO) usage</h4>
      <div class="d-flex align-items-end">
        <span class="balance">{{getCurrentAmountSpentOnTier(itemsMo)}}</span>
        <span class="text-primary fw-bold p-12">{{progressMo.label}}</span>
      </div>
      <app-billing-progress [total]="progressMo.total" [current]="progressMo.current" [parts]="progressMo.parts"></app-billing-progress>

      <ul class="quotas-list mt-0_6">
        <li *ngFor="let item of itemsMo; let i = index;" [style.width.%]="100 / itemsMo.length">
          {{getRatePerTest(itemsMo, i)}}/test
        </li>
      </ul>
    </div>
  </ng-container>

  <ng-container *ngIf="progressVoice">
    <div class="card">
      <h4>CLI Testing usage</h4>
      <div class="d-flex align-items-end">
        <span class="balance">{{getCurrentAmountSpentOnTier(itemsVoice)}}</span>
        <span class="text-primary fw-bold p-12">{{progressVoice.label}}</span>
      </div>
      <app-billing-progress [total]="progressVoice.total" [current]="progressVoice.current" [parts]="progressVoice.parts"></app-billing-progress>

      <ul class="quotas-list mt-0_6">
        <li *ngFor="let item of itemsVoice; let i = index;" [style.width.%]="100 / itemsVoice.length">
          {{getRatePerTest(itemsVoice, i)}}/test
        </li>
      </ul>
    </div>
  </ng-container>

  <ng-container *ngIf="progressFlashCall">
    <div class="card">
      <h4>Flash call usage</h4>
      <div class="d-flex align-items-end">
        <span class="balance">{{getCurrentAmountSpentOnTier(itemsFlashCall)}}</span>
        <span class="text-primary fw-bold p-12">{{progressFlashCall.label}}</span>
      </div>
      <app-billing-progress [total]="progressFlashCall.total" [current]="progressFlashCall.current" [parts]="progressFlashCall.parts"></app-billing-progress>

      <ul class="quotas-list mt-0_6">
        <li *ngFor="let item of itemsFlashCall; let i = index;" [style.width.%]="100 / itemsFlashCall.length">
          {{getRatePerTest(itemsFlashCall, i)}}/test
        </li>
      </ul>
    </div>
  </ng-container>

  <ng-container *ngIf="analyticsTariff">
    <div class="card analytics-tariff">
      <div class="captions">
        <h4>Analytics service</h4>
        <div class="d-flex mt-0_8 mb-0_8 align-items-baseline">
          <span class="commitment-balance">{{ analyticsTariff.rate | currency:'EUR':'symbol':'1.1-3' }}</span> <span class="ms-0_6">per month</span>
        </div>
        <div>
          Our analytics service is a powerful tool that provides you with in-depth insights into your testing history. <br>
          It provides a comprehensive analysis of your past test results, offering valuable data such as delivery rates over time, percentage of
          different statuses, delivery delays, SMSC information etc.
        </div>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="tiers.length">
    <h2 class="subtitle">Available plans</h2>
    <div class="pricing-plans">
      <div *ngFor="let item of tiers" class="pricing-plan card">
        <h2 class="title">{{ item.serviceType }}</h2>
        <div class="body">
          <ul>
            <li>
              <span class="gray">Rate per product/test -</span> €{{ item.ratePerUnit }}
            </li>
            <li>
              <span class="gray">Volume quota -</span> {{ item.quota }}
            </li>
          </ul>
        </div>
        <div class="footer">
          <div class="commitment">
            <h1>€{{ item.commitment }}</h1>
          </div>
          <button type="button" class="btn top-up">Contact us</button>
        </div>
      </div>
    </div>
  </ng-container>
  <div class="alert alert-primary">
    <div class="description">
      For more information about your pricing, please contact your account manager. <br>
      <a class="text-primary-p8" *ngIf="user?.ownerEmail" [href]="'mailto:' + user?.ownerEmail" target="_blank"
        rel="noopener noreferrer">{{user?.ownerEmail}}</a>
      <a class="text-primary-p8" *ngIf="!user?.ownerEmail" href="mailto:sales@telqtele.com" target="_blank" rel="noopener noreferrer">sales&#64;telqtele.com</a>
    </div>
  </div>
</div>
